exports.ASSISTANCE_RESULT_STATUS_RESOLVED = 'resolved';

exports.ASSISTANCE_RESULT_STATUS_URGENT = 'urgent';

exports.ASSISTANCE_RESULT_STATUS_REFERRED = 'referred';

exports.ASSISTANCE_RESULT_STATUS_CANCELED = 'canceled';

exports.ASSISTANCE_RESULT_STATUS_UNKNOWN = 'unknown';
